import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHero from "components/SectionHero/SectionHero";
import { useEffect } from "react";

function PageHome() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <>
      <div className="nc-PageHome relative overflow-hidden">
        <SectionHero className="" />

        <div className="container relative" style={{ padding: "0px" }}>
          <div id="section">
            <div className="container relative py-16">
              <SectionGridFeaturePlaces />
            </div>
            {/* <div className="container py-16 lg:py-28 space-y-16 ">
              <SectionHero
                rightImg={rightImg}
                heading={"Your Journey Starts with "+ {companyDetails?.seo_title}}
                btnText=""
                subHeading={globalJson?.about_us_para}
              />
            </div> */}
            {/* <div className="container py-16 lg:py-28 space-y-16 ">
              <WhyChooseUs />
            </div> */}

            {/* <div className="relative py-16">
              <SectionClientSay uniqueClassName="PageAbout_" />
            </div> */}
          </div>
        </div>
        {/* <div className="container relative py-16">
          <RentalPolicies />
        </div> */}
      </div>
    </>
  );
}

export default PageHome;
